import CSS from 'csstype';
import { isUndefined } from 'lodash-es';
import React from 'react';

import {
  getCustomTag,
  getResponsiveStyle,
  getSpacingStyle,
  ILayoutProps,
  ISpacingProps,
  spacing,
} from '~/src/dash/components/layout/common';
import { useBaseState } from '~/src/dash/views/base/contexts';

interface IColProps extends ILayoutProps, ISpacingProps {
  width?: number | string;
  // use flex when you want this col to take up any remaining empty space
  // must use on only one col inside the 'Cols' component
  flex?: boolean;
  displayFlex?: boolean;
  onClick?: (props: any | null) => void;
  onMouseEnter?: (props: any | null) => void;
  onMouseLeave?: (props: any | null) => void;
}

export const Col = ({
  onClick,
  onMouseEnter,
  onMouseLeave,
  flex,
  displayFlex,
  width,
  noPadding,
  extraSmallPadding,
  smallPadding,
  basePadding,
  largePadding,
  extraLargePadding,
  hugePadding,
  noHorizontalPadding,
  extraSmallHorizontalPadding,
  smallHorizontalPadding,
  horizontalPadding,
  largeHorizontalPadding,
  extraLargeHorizontalPadding,
  hugeHorizontalPadding,
  noVerticalPadding,
  extraSmallVerticalPadding,
  smallVerticalPadding,
  verticalPadding,
  largeVerticalPadding,
  extraLargeVerticalPadding,
  hugeVerticalPadding,
  extraSmallPaddingV2,
  smallPaddingV2,
  basePaddingV2,
  largePaddingV2,
  extraLargePaddingV2,
  hugePaddingV2,
  noHorizontalPaddingV2,
  extraSmallHorizontalPaddingV2,
  smallHorizontalPaddingV2,
  horizontalPaddingV2,
  largeHorizontalPaddingV2,
  extraLargeHorizontalPaddingV2,
  hugeHorizontalPaddingV2,
  noVerticalPaddingV2,
  extraSmallVerticalPaddingV2,
  smallVerticalPaddingV2,
  verticalPaddingV2,
  largeVerticalPaddingV2,
  extraLargeVerticalPaddingV2,
  hugeVerticalPaddingV2,
  paddingTop,
  paddingRight,
  paddingBottom,
  paddingLeft,
  marginTop,
  marginRight,
  marginBottom,
  marginLeft,
  style,
  responsive,
  extraLargeStyle,
  largeStyle,
  mediumStyle,
  smallStyle,
  extraSmallStyle,
  children,
  innerRef,
  className = '',
  tag,
  cypressID,
}: IColProps) => {
  const mediaSize = responsive ? useBaseState().mediaSize : 'extraSmall';
  const addOptionalStyles = () => {
    const styles = {} as CSS.Properties;
    if (!isUndefined(width)) {
      if (typeof width === 'number') {
        styles.width = `${width}px`;
      } else if (typeof width === 'string') {
        styles.width = width;
      }
    }
    if (flex) {
      styles.flex = '1 1 0%';
    }
    if (displayFlex) {
      styles.display = 'flex';
    }
    return styles;
  };

  return (
    <div
      ref={innerRef}
      {...(onClick && { onClick })}
      {...(onMouseEnter && { onMouseEnter })}
      {...(onMouseLeave && { onMouseLeave })}
      className={className}
      data-cy={cypressID}
      style={{
        ...getCustomTag('COL', tag),
        position: 'relative',
        ...addOptionalStyles(),
        ...getSpacingStyle({
          defaultPadding: spacing.none,
          noPadding,
          extraSmallPadding,
          smallPadding,
          basePadding,
          largePadding,
          extraLargePadding,
          hugePadding,
          noHorizontalPadding,
          extraSmallHorizontalPadding,
          smallHorizontalPadding,
          horizontalPadding,
          largeHorizontalPadding,
          extraLargeHorizontalPadding,
          hugeHorizontalPadding,
          noVerticalPadding,
          extraSmallVerticalPadding,
          smallVerticalPadding,
          verticalPadding,
          largeVerticalPadding,
          extraLargeVerticalPadding,
          hugeVerticalPadding,
          extraSmallPaddingV2,
          smallPaddingV2,
          basePaddingV2,
          largePaddingV2,
          extraLargePaddingV2,
          hugePaddingV2,
          noHorizontalPaddingV2,
          extraSmallHorizontalPaddingV2,
          smallHorizontalPaddingV2,
          horizontalPaddingV2,
          largeHorizontalPaddingV2,
          extraLargeHorizontalPaddingV2,
          hugeHorizontalPaddingV2,
          noVerticalPaddingV2,
          extraSmallVerticalPaddingV2,
          smallVerticalPaddingV2,
          verticalPaddingV2,
          largeVerticalPaddingV2,
          extraLargeVerticalPaddingV2,
          hugeVerticalPaddingV2,
          paddingTop,
          paddingRight,
          paddingBottom,
          paddingLeft,
          marginTop,
          marginRight,
          marginBottom,
          marginLeft,
        }),
        ...style,
        ...getResponsiveStyle({
          responsive,
          mediaSize,
          extraLargeStyle,
          largeStyle,
          mediumStyle,
          smallStyle,
          extraSmallStyle,
        }),
      }}
    >
      {children}
    </div>
  );
};
